export var EksClusterRestoreDestinationType;
(function (EksClusterRestoreDestinationType) {
    EksClusterRestoreDestinationType["EKS_CLUSTER_RESTORE_DESTINATION_TYPE_SOURCE_CLUSTER"] = "SOURCE_CLUSTER";
    EksClusterRestoreDestinationType["EKS_CLUSTER_RESTORE_DESTINATION_TYPE_EXISTING_CLUSTER"] = "EXISTING_CLUSTER";
})(EksClusterRestoreDestinationType || (EksClusterRestoreDestinationType = {}));
